import { useParams } from 'react-router-dom';
import { useEffect } from "react";
import FicheSCI from './FicheSCI';

export default function FicheSCIAuto({ setSelectedSCI }) {
  const { id } = useParams();

useEffect(() => {
    setSelectedSCI(id);
  }, [id, setSelectedSCI]);

  return <FicheSCI sciId={id} />;
}